import { AppTourStep, TooltipRelativePosition } from 'Components/AppTour';
import { NotifyPhaserEvents } from 'Phaser/EventBus2';
import { COLORBLIND_TYPE, isCapacitorNative } from 'Utils/Constants';
import {
  NOT_GRADED_TEXT,
  NOT_GRADED_TITLE,
  UNGRADED_TIP_FEATURE,
  UngradedLessonTip,
} from 'Utils/playAlong/ungradedTour';

/** The tier pills under the level name, which the Tiers tip points at. */
export const LESSON_TIER_PILLS_ID = 'lesson-tier-pills';

const tipSteps = (cbType: COLORBLIND_TYPE | null): Record<UngradedLessonTip, AppTourStep> => ({
  play_button: {
    stepKey: 'play_button',
    targetId: 'playButton',
    title: 'Play Button',
    content: isCapacitorNative()
      ? 'Tap the play button to start the level.'
      : 'Tap the play button or hit the spacebar to start the level.',
    position: TooltipRelativePosition.LEFT,
  },
  play_along: {
    stepKey: 'play_along',
    targetId: 'game-container',
    title: 'Playing Notes',
    content:
      'Play along with the music in time with the metronome. It keeps going as long as you do.',
    position: TooltipRelativePosition.BOTTOM,
    positionOffset: [0, -200],
    preStepFunction: () => NotifyPhaserEvents.SetAppTourStep({ step: 'playback', cbType }),
    onClose: () => NotifyPhaserEvents.EndTour(),
  },
  // Points at the accuracy pill, which stays blank: nothing is set up for it.
  not_graded: {
    stepKey: 'not_graded',
    targetId: 'accuracy',
    title: NOT_GRADED_TITLE,
    content: NOT_GRADED_TEXT,
    position: TooltipRelativePosition.LEFT,
    feature: UNGRADED_TIP_FEATURE.not_graded,
  },
  // Unlike the graded tempo step, this one leaves the player's tempo alone.
  tempo: {
    stepKey: 'tempo',
    targetId: 'tempo',
    title: 'Tempo',
    content: 'Set the tempo that works for you.',
    position: TooltipRelativePosition.LEFT,
    feature: UNGRADED_TIP_FEATURE.tempo,
  },
  tiers: {
    stepKey: 'tiers',
    targetId: LESSON_TIER_PILLS_ID,
    title: 'Tiers',
    content: 'Some levels have tiers. Play the later tiers to turn up the difficulty.',
    position: TooltipRelativePosition.BOTTOM,
    feature: UNGRADED_TIP_FEATURE.tiers,
  },
});

/** The sight reading tour steps for these tips, for a player the app cannot hear. */
export const ungradedLessonTourSteps = (
  tips: readonly UngradedLessonTip[],
  cbType: COLORBLIND_TYPE | null,
): AppTourStep[] => {
  const steps = tipSteps(cbType);
  return tips.map((tip) => steps[tip]);
};
